// extracted by mini-css-extract-plugin
export default {"copyButton":"copy-voucher-code_copyButton__OOtWf"};